import { z } from 'zod'

export function validateCpfCnpj(value: string): boolean {
  // Remove caracteres não numéricos
  const numbers = value.replace(/\D/g, '')

  if (numbers.length === 11) {
    // Validação CPF
    if (/^(\d)\1{10}$/.test(numbers)) return false // Rejeita CPFs com números iguais (ex: 111.111.111-11)

    let sum = 0
    let remainder

    // Valida primeiro dígito
    for (let i = 1; i <= 9; i++) {
      sum = sum + parseInt(numbers.substring(i - 1, i), 10) * (11 - i)
    }
    remainder = (sum * 10) % 11
    if (remainder === 10 || remainder === 11) remainder = 0
    if (remainder !== parseInt(numbers.substring(9, 10), 10)) return false

    // Valida segundo dígito
    sum = 0
    for (let i = 1; i <= 10; i++) {
      sum = sum + parseInt(numbers.substring(i - 1, i), 10) * (12 - i)
    }
    remainder = (sum * 10) % 11
    if (remainder === 10 || remainder === 11) remainder = 0
    if (remainder !== parseInt(numbers.substring(10, 11), 10)) return false

    return true
  } else if (numbers.length === 14) {
    // Validação CNPJ
    if (/^(\d)\1{13}$/.test(numbers)) return false

    let size = numbers.length - 2
    let base = numbers.substring(0, size)
    const digits = numbers.substring(size)
    let sum = 0
    let pos = size - 7

    // Valida primeiro dígito
    for (let i = size; i >= 1; i--) {
      sum += parseInt(base.charAt(size - i), 10) * pos--
      if (pos < 2) pos = 9
    }
    let result = sum % 11 < 2 ? 0 : 11 - (sum % 11)
    if (result !== parseInt(digits.charAt(0), 10)) return false

    // Valida segundo dígito
    size = size + 1
    base = numbers.substring(0, size)
    sum = 0
    pos = size - 7
    for (let i = size; i >= 1; i--) {
      sum += parseInt(base.charAt(size - i), 10) * pos--
      if (pos < 2) pos = 9
    }
    result = sum % 11 < 2 ? 0 : 11 - (sum % 11)
    if (result !== parseInt(digits.charAt(1), 10)) return false

    return true
  }

  return false
}

export const onboardingSchema = z.object({
  fullName: z.string().min(5, 'O nome deve ter pelo menos 5 caracteres'),
  document: z.string().refine((val) => validateCpfCnpj(val), {
    message: 'CPF ou CNPJ inválido',
  }),
})

export type OnboardingData = z.infer<typeof onboardingSchema>
